import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { History as HistoryIcon, Search } from "lucide-react";
import { PLATFORM_META } from "@/lib/platforms";
import { useNavigate } from "react-router-dom";

export default function History() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/checker/history")
      .then((r) => setItems(r.data.items || []))
      .finally(() => setBusy(false));
  }, []);

  return (
    <div className="max-w-4xl">
      <div className="mb-5 flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center border border-[#1a1a1a] bg-[#0a0a0a] rounded-xl text-[#9D4EDD]">
          <HistoryIcon size={18} />
        </div>
        <div>
          <div className="gc-label">HESAP</div>
          <h1 className="font-heading text-2xl md:text-3xl font-black leading-none mt-1">
            Sorgu <span className="text-[#9D4EDD]">Geçmişi</span>
          </h1>
        </div>
      </div>

      <div className="gc-card p-4">
        {busy && (
          <div className="text-sm font-mono text-[#A1A1AA] py-6 text-center">
            Yükleniyor…
          </div>
        )}
        {!busy && items.length === 0 && (
          <div className="text-sm text-[#A1A1AA] py-6 text-center">
            Henüz sorgu yapmadınız. Bir platform seç ve ilk sorgunu çalıştır.
          </div>
        )}
        {!busy && items.length > 0 && (
          <div className="divide-y divide-[#141414]">
            {items.map((h, i) => {
              const meta = PLATFORM_META[h.platform || "discord"] || PLATFORM_META.discord;
              const Icon = meta.Icon;
              const q = h.query || h.discord_id;
              return (
                <div key={i} className="py-3 flex items-center gap-3">
                  <span
                    className="w-8 h-8 flex items-center justify-center border border-[#1a1a1a] bg-[#050505] rounded-lg shrink-0"
                    style={{ color: meta.color }}
                  >
                    <Icon size={13} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-mono text-white truncate">{q}</div>
                    <div className="text-[10px] font-mono text-[#525252]">
                      {(h.platform || "discord").toUpperCase()} ·{" "}
                      {h.created_at?.slice(0, 16).replace("T", " ")}
                    </div>
                  </div>
                  <span
                    className={`gc-badge ${
                      h.found > 0 ? "gc-badge-green" : ""
                    }`}
                  >
                    {h.found} sonuç
                  </span>
                  <button
                    className="gc-btn-ghost !py-1.5 !px-2 text-xs"
                    onClick={() =>
                      navigate(
                        `/checker/${h.platform || "discord"}?id=${encodeURIComponent(q)}`,
                      )
                    }
                    title="Tekrar sorgula"
                  >
                    <Search size={12} />
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
